import * as R from "ramda"

export default () => {
  // TODO: use another routing library or native router location
  const result = document.location.pathname.split("/").filter(R.identity)[0]

  // Checking whether result is a number, to cover the cases when we accidentally get store id on the non dashboard routes such as sign in
  return !isNaN(+result) ? result : undefined
}
